const locale = {
	// #region People fields
	DETAILS_PEOPLE_FIELD_TITLE: 'Title',
	DETAILS_PEOPLE_FIELD_NAME: 'Name',
	DETAILS_PEOPLE_FIELD_SURNAME: 'Surname',
	DETAILS_PEOPLE_FIELD_STATUS: 'People Status',
	DETAILS_PEOPLE_FIELD_TYPE: 'People Type',
	DETAILS_PEOPLE_FIELD_ASSIGNED_USER: 'Internal assigned User',
	DETAILS_PEOPLE_FIELD_ASSIGNED_USER_2: 'External assigned User',
	DETAILS_PEOPLE_FIELD_BIRTHDAY: 'Birthday',
	DETAILS_PEOPLE_FIELD_WARNING: 'Warning',
	DETAILS_PEOPLE_FIELD_BLOCKED: 'Blocked',
	DETAILS_PEOPLE_FIELD_TAGS: 'Tags',
	DETAILS_PEOPLE_FIELD_COMPANY: 'Company',
	DETAILS_PEOPLE_FIELD_MARKETINGACTION: 'Origin Marketing Action',
	DETAILS_PEOPLE_FIELD_COMMERCIALCAMPAIGN: 'Origin Commercial Campaign',
	DETAILS_PEOPLE_FIELD_LEADCHANNEL: 'Lead Channel',
	DETAILS_PEOPLE_FIELD_BROKER_COMPANY: 'Broker Company',
	DETAILS_PEOPLE_FIELD_BROKER_PERSON: 'Broker People',
	// #endregion

	// #region User Avatar
	PEOPLE_AVATAR_SECTION: 'Avatar',
	PEOPLE_AVATAR_SUBHEADER: 'View or update the person avatar'
	// #endregion
};

export default locale;
